import { render, staticRenderFns } from "./AddDailyAnswers.vue?vue&type=template&id=3f897094&"
import script from "./AddDailyAnswers.vue?vue&type=script&lang=js&"
export * from "./AddDailyAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports